import axios from "axios";
import CryptoJS from 'crypto-js';

const baseURL = `https://autodukan.com/gms`;
// const baseURL = `https://dev.autodukan.com/autodukan/v1`;
// const baseURL =`http://localhost/autodukan_backend`;


const decryptData = (encryptedData) => {
  const secretKey = 'base64:v+fOFlHRke4dw93FNXDWIOI4lMiNXHVY+8gagh4rmzY='; 
  try {

    // Decode the Base64 encoded string
    const jsonStr = atob(encryptedData);
    const json = JSON.parse(jsonStr);

    // Extract the payload
    const payload = json.value;
    const iv = CryptoJS.enc.Base64.parse(json.iv);

    // Convert the secret key from base64
    const key = CryptoJS.enc.Base64.parse(secretKey.split('base64:')[1]);

    // Decrypt
    const decrypted = CryptoJS.AES.decrypt(payload, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    // Convert to UTF8 and parse JSON
    const decryptedData = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));

    return decryptedData;
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};

export const getcatelogsubcategory = async (modification_id,cat_id,brand_id) => {

  try {
   
    let response = await axios({
      method: "POST",
      url: `${baseURL}/api/customer/get-sub-cat`,
      data: {
       modification_id: modification_id,
       cat_id: cat_id,
       brand_id: brand_id
      },
    });

    return response.data;

  } catch (error) {
    console.error("Error fetching catelog subcategorys:", error);
    return error?.response?.data;
  }
};

export const getcatelogcategory = async (param1,param2) => {

  try {
    const response = await axios.get(
      `${baseURL}/api/customer/get-cat?modification_id=${param1}&brand_id=${param2}`,
    );
    return response.data;
    // const data = response?.data.data;  
    // const decryptedData = decryptData(data.encryptedData);

    // const result = {
    //   status: response?.data.status,
    //   code: response?.data.code,
    //   msg: response?.data.msg,
    //   data: decryptedData
    // }

    // return result;
  } catch (error) {
    console.error("Error fetching catelog category:", error);
    return error?.response?.data; // Rethrow the error so it can be handled by the caller
  }
};

export const getCategory = async () => {
  try {
    let response = await axios({
      method: "GET",
      url: `${baseURL}/api/customer/category`,
    });
    // return response.data;
    const data = response?.data.data;
    const decryptedData = decryptData(data.encryptedData);

    const result = {
      status: response?.data.status,
      code: response?.data.code,
      msg: response?.data.msg,
      data: decryptedData
    }
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const getSubCategory = async (category_id) => {
  try {
    const response = await axios.get(`${baseURL}/api/customer/subcategory`, {
      params: {
        category_id: category_id,
      },
    });
    // return response.data.data;
    const data = response?.data.data;
    const decryptedData = decryptData(data.encryptedData);
    
    const result = {
      status: response?.data.status,
      code: response?.data.code,
      msg: response?.data.msg,
      data: decryptedData
    }
    
    return result;
  } catch (error) {
    console.error("Error fetching subcategorys:", error);
    throw error; // Rethrow the error so it can be handled by the caller
  }
};

export const getAllCategoryList = async () => {
  try {
    let response = await axios({
      method: "GET",
      url: `${baseURL}/api/customer/cat_subcategory`,
    });
    return response.data.data;
  } catch (error) {
    console.log(error);
  }
};
export const getcatalogSearch = async (param1,param2,param3) => {
  try {
    let response = await axios({
      method: "POST",
      url: `${baseURL}/api/customer/catalogue_search`,
      data: {
        modification_id: param1,
        brand_id: param2,
        search_term: param3,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}
